import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import GridItem from './GridItem';

function customEquality(option, value) {
    return option === value || value === 'advanced'; 
  }

const AutoInput = ({label,setInput,input,data})=>{

    const [value, setValue] = React.useState(input);

    const options = React.useMemo(() => (Array.isArray(data) ? data : []), [data]);

const getOptionLabel = (option) => {
    return  option
};

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setInput(newValue);
    }

return(
	<GridItem >
        <Autocomplete
            value={value}
            onChange={handleChange}
            options={options}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={customEquality}
            
            renderInput={(params) => (
            <TextField
                {...params}
                label={`${label} *`}
                sx={{width:{xs:350,md:300}}}
                value={value}   
                // variant='filled'   
                placeholder={`${label}`}
            
            />
            )}
        />	
	</GridItem>


)
}

export default AutoInput